import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { notificationBus } from './utils/notificationBus'
import { confirmBus } from './utils/confirmBus'

axios.defaults.baseURL = '/api'
axios.interceptors.request.use(config => {
  // 从 localStorage 获取 token
  const token = localStorage.getItem('jwt_token');
  // 如果 token 存在，则在请求头中添加 Authorization 字段
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});
const app = createApp(App)

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$notify = notificationBus;
app.config.globalProperties.$confirm = confirmBus;

app.use(store)
app.use(router)
app.mount('#app')
